
import '../../styles/_contactform.scss'

const ContactSection = () => {
    return (
        <section className="py-3">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="contact-wrapper">
                            <div className="row g-0">
                                <div className="col-md-7">
                                    <div className="contact-form">
                                        <h3 className="mb-4 text-uppercase">Start a Conversation</h3>
                                        <div className="klaviyo-form-WUdJWC"></div>
                                    
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className="contact-info h-100">
                                        <h3 className="mb-4 text-uppercase">Offices</h3>
                                        <p className="mb-4">
                                            We'd love to hear from you. Please fill out the form or contact us using the information below.
                                        </p>

                                        <div className="contact-item">
                                            <div className="contact-icon">
                                                <i className="bi bi-geo-alt-fill"></i>
                                            </div>
                                            <div>
                                                <h6 className="mb-0">Address</h6>
                                                <p className="mb-0">
                                                    6 Saint John's Lane 
                                                    <br />
                                                    New York, NY 10013
                                                </p>
                                            </div>
                                        </div>

                                        <div className="contact-item">
                                            <div className="contact-icon">
                                                <i className="bi bi-telephone-fill"></i>
                                            </div>
                                            <div>
                                                <h6 className="mb-0">Phone</h6>
                                                <a 
    className='text-white text-decoration-none' 
    href="tel:+19177453620" 
    aria-label="Call us at +1 (917) 745-3620"
  >
    +1 (917) 745-3620
  </a>
                                            </div>
                                        </div>

                                        <div className="contact-item">
                                            <div className="contact-icon">
                                                <i className="bi bi-envelope-fill"></i>
                                            </div>
                                            <div>
                                                <h6 className="mb-0">Email</h6>
                                                     <a className='text-white text-decoration-none' href="mailto:ClientServices@brandacumen.co" aria-label="Email client services at clientservices@brandacumen.co">ClientServices@brandacumen.co</a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;